import { StoreItem, DispatchEvent } from './Store';

declare type reduceFunction<T, Payload = any> = (state: StoreItem<T>, payload: Payload) => StoreItem<T>;

export default class Reducer<T> {
    reduceFunctions: { [actionType: string]: reduceFunction<T> } = {};

    register<Payload>(actionType: string, reduce: reduceFunction<T, Payload>): this {
        this.reduceFunctions[actionType] = reduce;
        return this;
    }

    registers<Payload>(actionTypes: string[], reduce: reduceFunction<T, Payload>): this {
        actionTypes.forEach(a => this.reduceFunctions[a] = reduce);
        return this;
    }

    reduce(state: StoreItem<T>, action: DispatchEvent<any>) {
        let newState = state;
        if (action && action.type && this.reduceFunctions[action.type]) {
            newState = this.reduceFunctions[action.type](state, action.payload);
        }
        return newState;
    }
}